import { apiClient } from './client';
import type { ApiResponse, PaginatedResponse, Contact } from '@/types/api.types';

export const contactsApi = {
  list: (params?: { page?: number; pageSize?: number; search?: string }) =>
    apiClient.get<PaginatedResponse<Contact>>('/contacts', { params }),

  create: (data: { phone: string; name?: string; metadata?: Record<string, unknown> }) =>
    apiClient.post<ApiResponse<Contact>>('/contacts', data),

  importCsv: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return apiClient.post<ApiResponse<{ created: number; skipped: number; errors: Array<{ phone: string; reason: string }> }>>(
      '/contacts/import',
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  },

  update: (
    id: string,
    data: { phone?: string; name?: string | null; metadata?: Record<string, unknown> | null },
  ) => apiClient.patch<ApiResponse<Contact>>(`/contacts/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/contacts/${id}`),
};
